import { createSlice } from "@reduxjs/toolkit";
const name = "users";

const usersSlice = createSlice({
  name,
  initialState: {
    users: [],
    filteredUsers: [],
    isUsersLoading: false,
    isFilteredUsersLoading: false,
    selectedToggleBoxValue: "Name",
    searchInputValue: "",
    searchParams: null,
    error: null,

    isInviteRequestLoading: false,
    isResendRequestLoading: false,
    isVarifyRequestLoading: false,
  },
  reducers: {
    updateSearchParams: (state, action) => {
      const { selectedToggleBox, searchInput } = action.payload;
      state.selectedToggleBoxValue = selectedToggleBox;
      state.searchInputValue = searchInput;
    },

    getUsers: (state) => {
      state.isUsersLoading = true;
    },
    getUsersSuccess: (state, action) => {
      state.isUsersLoading = false;
      state.users = action.payload;
    },
    getUsersFailure: (state, action) => {
      state.isUsersLoading = false;
      state.error = action.payload;
    },

    getFilteredUsers: (state, action) => {
      state.isFilteredUsersLoading = true;
      state.searchParams = action.payload;
    },
    getFilteredUsersSuccess: (state, action) => {
      state.isFilteredUsersLoading = false;
      state.filteredUsers = action.payload;
    },
    getFilteredUsersFailure: (state, action) => {
      state.isFilteredUsersLoading = false;
      state.error = action.payload;
    },

    inviteUser: (state, action) => {
      state.isInviteRequestLoading = true;
    },
    inviteUserSuccess: (state) => {
      state.isInviteRequestLoading = false;
    },
    inviteUserFailure: (state, action) => {
      state.isInviteRequestLoading = false;
      state.error = action.payload;
    },

    resendUserSms: (state, action) => {
      state.isResendRequestLoading = true;
    },
    resendUserSmsSuccess: (state) => {
      state.isResendRequestLoading = false;
    },
    resendUserSmsFailure: (state, action) => {
      state.isResendRequestLoading = false;
      state.error = action.payload;
    },

    verifyUserPhone: (state, action) => {
      state.isVarifyRequestLoading = true;
    },
    verifyUserPhoneSuccess: (state) => {
      state.isVarifyRequestLoading = false;
    },
    verifyUserPhoneFailure: (state, action) => {
      state.isVarifyRequestLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  updateSearchParams,

  getUsers,
  getUsersFailure,
  getUsersSuccess,

  getFilteredUsers,
  getFilteredUsersFailure,
  getFilteredUsersSuccess,

  inviteUser,
  inviteUserFailure,
  inviteUserSuccess,

  resendUserSms,
  resendUserSmsFailure,
  resendUserSmsSuccess,

  verifyUserPhone,
  verifyUserPhoneFailure,
  verifyUserPhoneSuccess,
} = usersSlice.actions;

export default usersSlice.reducer;
